import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ContentSwitcher from '../ContentSwitcher/ContentSwitcher';
import useAdminDashboardCharts from './AdminDashboardCharts.hook';
import {
  adminDashboardAllChartsSection,
  adminDashboardSingleChartWrapper,
  adminDashboardTwoChartsSection,
} from './AdminDashboardCharts.style';
import { AdminDashboardChartsPropsType } from './AdminDashboardCharts.types';
import AdminDashboardBarChart from './Charts/AdminDashboardBarChart/AdminDashboardBarChart';
import AdminDashboardDoughnutChart from './Charts/AdminDashboardDoughnutChart/AdminDashboardDoughnutChart';
import AdminDashboardParetoChart from './Charts/AdminDashboardParetoChart/AdminDashboardParetoChart';
import AdminDashboardPieChart from './Charts/AdminDashboardPieChart/AdminDashboardPieChart';
import Box from 'yoda-ui/components/Box';

const AdminDashboardCharts: FC<AdminDashboardChartsPropsType> = ({ filters, chartsRef, triggerExportCharts }) => {
  const { t } = useTranslation();
  const {
    cepsByMonthAndProduct,
    cepsByMonthAndTa,
    cepsCountByMonthAndProduct,
    cepsCountByMonthAndTa,
    cepsPercentageOfApproved,
    countOfCepTacticsChannels,
    cepsByMonthAndProductLoading,
    cepsByMonthAndTaLoading,
    cepsCountByMonthAndProductLoading,
    cepsCountByMonthAndTaLoading,
    cepsPercentageOfApprovedLoading,
    countOfCepTacticsChannelsLoading,
  } = useAdminDashboardCharts(filters);

  return (
    <Box ref={ chartsRef } sx={ adminDashboardAllChartsSection }>
      <ContentSwitcher
        primaryContent={
          <AdminDashboardBarChart
            barData={ cepsByMonthAndProduct }
            loading={ cepsByMonthAndProductLoading }
            isProductGrouping={ true }
          />
        }
        secondaryContent={
          <AdminDashboardPieChart
            pieData={ cepsCountByMonthAndProduct }
            loading={ cepsByMonthAndTaLoading }
            isProductGrouping={ true }
          />
        }
        primaryTitle={ t('maya_admin_dashboard_product_bar_chart_title') }
        secondaryTitle={ t('maya_admin_dashboard_product_pie_chart_title') }
        primaryButtonLabel={ t('maya_admin_dashboard_bar_chart_button_title') }
        secondaryButtonLabel={ t('maya_admin_dashboard_pie_chart_button_title') }
        triggerExportCharts={ triggerExportCharts }
      />

      <ContentSwitcher
        primaryContent={
          <AdminDashboardBarChart
            barData={ cepsByMonthAndTa }
            loading={ cepsCountByMonthAndProductLoading }
          />
        }
        secondaryContent={
          <AdminDashboardPieChart
            pieData={ cepsCountByMonthAndTa }
            loading={ cepsCountByMonthAndTaLoading }
          />
        }
        primaryTitle={ t('maya_admin_dashboard_ta_bar_chart_title') }
        secondaryTitle={ t('maya_admin_dashboard_ta_pie_chart_title') }
        primaryButtonLabel={ t('maya_admin_dashboard_bar_chart_button_title') }
        secondaryButtonLabel={ t('maya_admin_dashboard_pie_chart_button_title') }
        triggerExportCharts={ triggerExportCharts }
      />

      <Box sx={ adminDashboardTwoChartsSection }>
        <Box sx={ adminDashboardSingleChartWrapper }>
          <AdminDashboardDoughnutChart
            title={ t('maya_admin_dashboard_doughnut_chart_title') }
            doughnutData={ cepsPercentageOfApproved }
            loading={ cepsPercentageOfApprovedLoading }
          />
        </Box>
        <ContentSwitcher
          primaryContent={
            <AdminDashboardParetoChart
              paretoData={ countOfCepTacticsChannels }
              loading={ countOfCepTacticsChannelsLoading }
            />
          }
          secondaryContent={
            <AdminDashboardPieChart
              pieData={ countOfCepTacticsChannels }
              loading={ countOfCepTacticsChannelsLoading }
            />
          }
          primaryTitle={ t('maya_admin_dashboard_pareto_chart_title') }
          secondaryTitle={ t('maya_admin_dashboard_pie_chart_channels_title') }
          primaryButtonLabel={ t('maya_admin_dashboard_bar_chart_button_title') }
          secondaryButtonLabel={ t('maya_admin_dashboard_pie_chart_button_title') }
          triggerExportCharts={ triggerExportCharts }
        />
      </Box>
    </Box>
  );
};

export default AdminDashboardCharts;
